import { BenchmarkingTemporalType } from 'components/filter/modules/benchmarking/types';

const monthlyFormatter = (locale?: string) =>
  new Intl.DateTimeFormat(locale ?? 'en', {
    year: 'numeric',
    month: 'long',
  });

const weeklyFormatter = (locale?: string) =>
  new Intl.DateTimeFormat(locale ?? 'en', {
    dateStyle: 'short',
  });

export const formatRange = (
  from?: string,
  to?: string,
  temporalType?: BenchmarkingTemporalType,
  locale?: string
): string => {
  if (!from || !to) return '';
  const fromDate = new Date(from);
  const toDate = new Date(to);
  const formatter = temporalType === 'WEEKLY' ? weeklyFormatter(locale) : monthlyFormatter(locale);
  return `${formatter.format(fromDate)} – ${formatter.format(toDate)}`;
};
